<div class="mt-0">
  <h4>{{'entity.projects'|translate}} {{'ui.and'|translate|lowercase}} {{'ui.deliveries'|translate|lowercase}}</h4>
  <div *ngIf="data" class="operational summary clearfix">
    <div class="clearfix">
      <div class="data-column big">
        <div class="title">{{'production.to-produce'|translate}}</div>
        <div class="value">{{data.plannedAmount | float:2}} m<sup>3</sup></div>
      </div>
      <div class="data-column big">
        <div class="title">{{'order.delivered'|translate}}</div>
        <div class="value">{{data.deliveredAmount | float:2}} m<sup>3</sup></div>
      </div>
      <div class="data-column big">
        <div class="title">{{'entity.outstanding'|translate}}</div>
        <div class="value">{{data.remainingAmount | float:2}} m<sup>3</sup></div>
      </div>
      <div class="data-column big">
        <div class="title">{{'entity.projects'|translate}}</div>
        <div class="value">{{data.projectCount}}</div>
      </div>
      <div class="data-column big">
        <div class="title">{{'project.orders'|translate}}</div>
        <div class="value">{{data.orderCount}}</div>
      </div>
      <div class="data-column big">
        <div class="title">{{'quantity.deviations'|translate}}</div>
        <div class="value">{{data.deviationCount}}</div>
      </div>
    </div>
    <div class="clearfix mt-2">
      {{'order.production'|translate}}{{'ui.progress'|translate|lowercase}}
      <ngb-progressbar class="mt-1 mb-1" textType="white" [value]="data.progressPercentage" [showValue]="true"></ngb-progressbar>
      <div *ngIf="data.deliveredAmount" class="float-left"><b>{{data.deliveredAmount | float:2}}</b> m<sup>3</sup> {{'order.delivered'|translate|lowercase}}</div>
      <div *ngIf="data.plannedAmount" class="float-right"><b>{{data.plannedAmount | float:2}}</b> m<sup>3</sup> {{'order.planned'|translate|lowercase}}</div>
    </div>
  </div>
</div>
